import * as z from "zod";

/**
 * PPU-intent self-serve wizard accept. Seeds artifacts + opens Conversion;
 * writes NO billing record and NO trialType (this motion has no free trial).
 *
 * Web pixel activation after enable is best-effort: Shopify scope/API failures
 * must not fail the RPC (Conversion is already on).
 */
export const acceptPpuIntentSelfServe = {
  name: "acceptPpuIntentSelfServe" as const,
  input: z.object({}),
  output: z.object({}),
};
